<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import KanbanPaywall from './Index.vue';

const props = defineProps({
  view: {
    type: [Object, Function],
    required: true,
  },
});

const { currentAccount } = useAccount();

const isKanbanEnabled = computed(
  () => currentAccount.value?.settings?.alex_kanban_enabled === true
);
</script>

<template>
  <component :is="props.view" v-if="isKanbanEnabled" />
  <KanbanPaywall v-else />
</template>
